import { render, staticRenderFns } from "./ComplementaSolicitante.vue?vue&type=template&id=364feabf"
import script from "./ComplementaSolicitante.vue?vue&type=script&lang=js"
export * from "./ComplementaSolicitante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('364feabf')) {
      api.createRecord('364feabf', component.options)
    } else {
      api.reload('364feabf', component.options)
    }
    module.hot.accept("./ComplementaSolicitante.vue?vue&type=template&id=364feabf", function () {
      api.rerender('364feabf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/cotejo/ComplementaSolicitante.vue"
export default component.exports